import React from 'react'

export default class DownloadWidget extends React.Component {
  constructor (props){
    super(props)

    this.state = {
      disabled: false,
      value: 'Lancer',
    }
  }

  onClick(e) {
    e.preventDefault()

    if (!this.state.disabled) {
      this.setState({
        disabled: true,
        value: 'Envoi...',
      })
    }

    this.props.download(this.props.url, this.props.tracker, (result) => {
      this.setState({
        disabled: false,
        value: 'Lancer',
      })
    })
  }

  render() {
    return (
      <div>
        <button className="btn btn-default" onClick={this.onClick.bind(this)} disabled={this.state.disabled}>
          { this.state.value }
        </button>
      </div>
    )
  }
}
